import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";

const requiredEnvVars = [
	"REACT_APP_FIREBASE_API_KEY",
	"REACT_APP_FIREBASE_AUTH_DOMAIN",
	"REACT_APP_FIREBASE_PROJECT_ID",
	"REACT_APP_FIREBASE_STORAGE_BUCKET",
	"REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
	"REACT_APP_FIREBASE_APP_ID",
];

const missingEnvVars = requiredEnvVars.filter(
	(name) => !process.env[name] || process.env[name] === ""
);

if (missingEnvVars.length > 0) {
	console.error("Missing Firebase environment variables:", missingEnvVars);
	throw new Error(
		`Firebase configuration is incomplete. Create a frontend/.env.local file and define the required REACT_APP_* variables. Missing: ${missingEnvVars.join(", ")}`
	);
}

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(
	app,
	"https://ghana-ai-mental-health-default-rtdb.europe-west1.firebasedatabase.app/"
);

export default app;
